// Compatibility with some old browser
import {ShopComponent} from "./shop.component";

if(window.console && !window.console.debug) {
    window.console.debug = function(message: any) {console.log(message);}
}
if(window.console && !window.console.error) {
    window.console.error = function(message: any) {console.log(message);}
}
if(window.console && !window.console.info) {
    window.console.info = function(message: any) {console.log(message);}
}

/**
 * returns the users locale from the browser
 *
 * @returns {string}
 */
function initLocale() {
    let locale = 'en';
    if (navigator["browserLanguage"]) {
        locale = navigator["browserLanguage"];
    }
    else if (navigator.language) {
        locale = navigator.language;
    }
    switch(locale.substring(0,2)) {
        case 'gs':
        case 'ks':
            // workaround for ksh and gsw
            locale = 'de';
        case 'de':
            registerLocaleData(localeDE, 'de');
            break;
        case 'fr':
            registerLocaleData(localeFR, 'fr');
            break;
        case 'es':
            registerLocaleData(localeES, 'es');
            break;
        default:
            registerLocaleData(localeEN, locale.substring(0,2));
            locale = 'en';
            break;
    }
    return locale;
}

// Angular
import {NgModule, LOCALE_ID, ApplicationRef}      from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';

// vendors
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

// own components, classes
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {DonationModule} from "../donation/donation.module";
import {ShopListComponent} from "./shop.list.component";
import {ShopListItemComponent} from "./shop.list.item.component";
import {ShopDownloadComponent} from "./shop.download.component";
import {ShopCartIconComponent} from "./shop.cart.icon.component";
import {ShopDetailComponent} from "./shop.detail.component";
import {ShopCartComponent} from "./shop.cart.component";
import {GiftDonationComponent} from "../gift/gift.donation";
import {SelectComponent} from "../input/input.select.component";
import {OverlayComponent} from "../overlay/overlay.component";
import {ShopAmountSelectComponent} from "../shop/shop.amount-select.component";
import {ShopCartSummaryComponent} from '../shop/shop.cart.summary.component';
import {registerLocaleData} from "@angular/common";
import localeDE from "@angular/common/locales/de";
import localeFR from "@angular/common/locales/fr";
import localeES from "@angular/common/locales/es";
import localeEN from "@angular/common/locales/en";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, __twingle_translationUrl.replace(/language\.json/, ''), '.json');
}

// declare global vars
declare let __twingle_translationUrl: string;

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        DonationModule
    ],
    declarations: [ShopComponent, ShopListComponent, ShopListItemComponent, ShopCartIconComponent, ShopDetailComponent, ShopCartComponent, GiftDonationComponent, OverlayComponent, ShopDownloadComponent, ShopAmountSelectComponent, ShopCartSummaryComponent],
    providers: [
        { provide: LOCALE_ID, useValue: initLocale() }
    ]
})
export class ShopModule {
    /**
     * Methods controlls which component to bootstrap
     * @param appRef
     */
    ngDoBootstrap(appRef:ApplicationRef){
        if(document.getElementsByTagName("shop").length > 0) {
            appRef.bootstrap(ShopComponent);
        }
    }
}
